import * as React from 'react';
import { ContentWrapper } from '../ContentWrapper';
import { LandingBlock } from '../LandingBlock';
import { Form } from '../Form';

import * as styles from './styles.css';

export interface ISecondBlockForm {
  buttonTitle: string;
  error?: string;
  phone: string;
  loading: boolean;
  submitPhone(): void;
  setPhone(phone: string): void;
  setOpen(open: boolean): void;
}

export const SecondBlockForm: React.FC<ISecondBlockForm> = ({
  buttonTitle,
  error,
  loading,
  phone,
  submitPhone,
  setPhone,
  setOpen,
}) => {
  return (
    <LandingBlock>
      <ContentWrapper>
        <div className={styles['container']} id="second-form">
          <Form
            buttonTitle={buttonTitle}
            error={error}
            loading={loading}
            phone={phone}
            submitPhone={submitPhone}
            setPhone={setPhone}
            setOpen={setOpen}
          />
        </div>
      </ContentWrapper>
    </LandingBlock>
  );
};
